/* eslint-disable react-hooks/exhaustive-deps */
import styled from 'styled-components';
import PropTypes from 'prop-types';
import React, { useRef, useEffect, useCallback } from 'react';
import H4 from '@base/H4/H4';
import dateHelper from '@utils/dates';
import fetchVisibleItems from '@utils/viewportHelper';
import { useDispatchToStore } from '@hooks/reduxHooks';
import { fetchEductatorScheduledClasses } from '@actions/educator';
import InfiniteList from '@comp/InfiniteList/InfiniteList';
import ScheduleClassCard from '@educator/Composite/ScheduleClassCard/ScheduleClassCard';
import { Spacings, TextColors } from '../../../../styleConstants';

const ListWrapper = styled.div`
  grid-column: span 11;
  background-color: ${({ theme }) => theme.colors.base};
`;

const DateHeader = styled(H4)`
  margin-bottom: ${Spacings.SPACING_6B};
  background-color: ${({ theme }) => theme.colors.base};
  padding: ${Spacings.SPACING_4B} 0;
  z-index: 2;
  color: ${({ theme }) => theme.colors.fontGrey};
`;

const LiveClass = styled(ScheduleClassCard)`
  opacity: ${({ notAccessible }) => (notAccessible ? '0.5' : 1)};
`;

const ClassesList = ({
  schedule,
  setDatePointer,
  datePointer,
  goalColor,
  me,
  selectedGoal,
  unLiveURL,
  setAnchorEl,
  setTypeOfClass,
  setCurrentSession
}) => {
  const dispatch = useDispatchToStore();
  const VisibleBlocks = useRef();

  const loadMoreItems = () => {
    return dispatch(fetchEductatorScheduledClasses(datePointer, true));
  };

  const isNewDate = [];
  schedule.results.forEach((item, index) => {
    if (index === 0) isNewDate[index] = true;
    else if (
      new Date(schedule.results[index - 1].liveAt).getDate() !==
      new Date(item.liveAt).getDate()
    )
      isNewDate[index] = true;
    else isNewDate[index] = false;
  });

  const handleScroll = useCallback(() => {
    const listEl = document.getElementById('scheduleList');
    const headerBlocks = document.getElementsByClassName('date-stamp');
    VisibleBlocks.current = fetchVisibleItems(headerBlocks, listEl);
    const blockTop = VisibleBlocks.current[0]?.getBoundingClientRect().y;
    if (blockTop < 112) {
      setDatePointer(
        Number(VisibleBlocks.current[0].getAttribute('data-date'))
      );
    }
  }, [loadMoreItems, setDatePointer]);

  useEffect(() => {
    const listEl = document.getElementById('scheduleList');
    if (listEl) {
      window.addEventListener('scroll', handleScroll);
      return () => window.removeEventListener('scroll', handleScroll);
    }
  }, [handleScroll]);
  const renderEachClass = (item, index) => {
    const dateString = dateHelper.getDateShort(item.liveAt, false);
    return (
      <>
        {isNewDate[index] && (
          <div
            className="date-stamp"
            data-date={new Date(item.liveAt).getTime()}
            id={dateString}
          >
            <DateHeader>{dateString}</DateHeader>
          </div>
        )}
        <LiveClass
          classData={item}
          goalColor={goalColor}
          selectedGoal={selectedGoal}
          me={me}
          unLiveURL={unLiveURL}
          setAnchorEl={setAnchorEl}
          setTypeOfClass={setTypeOfClass}
          setCurrentSession={setCurrentSession}
        />
      </>
    );
  };
  if (!schedule) return null;
  return (
    <ListWrapper id="scheduleList">
      <InfiniteList
        loadMore={loadMoreItems}
        _renderItem={renderEachClass}
        data={schedule}
        gridColumn="span 10"
        loaderColor={TextColors.BLUE}
      />
    </ListWrapper>
  );
};

export default ClassesList;

ClassesList.propTypes = {
  schedule: PropTypes.objectOf(PropTypes.any),
  selectedGoal: PropTypes.objectOf(PropTypes.any),
  me: PropTypes.objectOf(PropTypes.any),
  setDatePointer: PropTypes.func.isRequired,
  datePointer: PropTypes.string,
  goalColor: PropTypes.string.isRequired,
  unLiveURL: PropTypes.string.isRequired,
  setAnchorEl: PropTypes.func.isRequired,
  setTypeOfClass: PropTypes.func.isRequired,
  setCurrentSession: PropTypes.func.isRequired
};

ClassesList.defaultProps = {
  schedule: null,
  selectedGoal: null,
  me: {},
  datePointer: new Date().getTime()
};
